module.exports = __webpack_public_path__ + "media/images/vp/icon.sliderarrow-2154664ed47a04b576d582524dfff409.svg";